/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Mon Mar 25 2024
 **/

import { Column, Row, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import * as S from "../../emotion";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";
import { Maybe } from "@/frameworks/libraries/components";
import { useProperties } from "@/frameworks/libraries/properties";

type PeerDetailProps = {
	callee?: WebServices.User.UserInfo;
};

export default function PeerDetail({ callee }: PeerDetailProps) {
	const properties = useProperties();

	return (
		<S.InfoWrap css={hoverScrollCss()}>
			<Column>
				<Typography.p typoSize="Title3">{_T("연락처")}</Typography.p>
				<Column gap={2}>
					<Typography.p typoSize="Body3">{callee?.username}</Typography.p>
					<Typography.p typoSize="Body3">{callee?.phoneNumber}</Typography.p>
				</Column>
			</Column>
			<Maybe test={Boolean(callee?.userStatus)}>
				<Column>
					<Typography.p typoSize="Title3">{_T("상태")}</Typography.p>
					<Row verticalAlign="center" gap={2}>
						<Maybe test={Boolean(callee?.userStatusEmoticonPath)}>
							<img
								style={{ width: "20px", height: "20px" }}
								src={properties.default.webDomain + callee?.userStatusEmoticonPath}
								alt={""}
							/>
						</Maybe>
						<Typography.p typoSize="Body3">{callee?.userStatus}</Typography.p>
					</Row>
				</Column>
			</Maybe>
			{callee?.shortDescription && (
				<Column>
					<Typography.p typoSize="Title3">{_T("한줄 소개")}</Typography.p>
					<Typography.p typoSize="Body3">{callee?.shortDescription}</Typography.p>
				</Column>
			)}
			{callee?.description && (
				<Column>
					<Typography.p typoSize="Title3">{_T("소개")}</Typography.p>
					<Typography.p typoSize="Body3">{callee?.description}</Typography.p>
				</Column>
			)}
		</S.InfoWrap>
	);
}
